import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Button,
  Form,
  Label,
  Input,
  Col,
  Row,
} from "reactstrap";
import axios from "axios";

import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";

function ColaboradoresCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_PUESTOS = process.env.REACT_APP_URL_PUESTOS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_PLANTELES = process.env.REACT_APP_URL_PLANTELES;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const URL_SIGNUP = process.env.REACT_APP_URL_USERS;
  const PLANTELES_GENERAL = process.env.REACT_APP_PLANTELES_GENERAL;
  const AREAS_GENERAL = process.env.REACT_APP_AREAS_GENERAL;
  const [text, setText] = useState(false);
  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  // const [identificacion, setIdentificacion] = useState("");
  // const [direccion, setDireccion] = useState("");
  // const [fecha_ingreso, setFechaIngreso] = useState([]);
  // const [fecha_nacimiento, setFechaNacimiento] = useState([]);
  const [telefono, setTelefono] = useState("");
  // const [frecuencia, setFrecuencia] = useState("");
  // const [contacto_emergencia, setContEmer] = useState("");
  // const [telefono_emergencia, setTelEmer] = useState("");
  // const [sueldo_actual, setSueldoActual] = useState("");
  const [observaciones, setObservaciones] = useState("");
  const [email, setEmail] = useState("");
  const [puestos, setPuestos] = useState([]);
  const [selectedPuesto, setSelectedPuesto] = useState("");
  // const [banco, setBanco] = useState("");
  // const [clabe, setClabe] = useState("");
  const [cobrador, setCobrador] = useState("No");
  const [acceso_sistema, setAccesoSistema] = useState("");
  // const [planteles, setPlanteles] = useState([]);
  const [selectedPlantel, setSelectedPlantel] = useState(process.env.REACT_APP_PLANTELES_GENERAL);
  // const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState(process.env.REACT_APP_AREAS_GENERAL);
  const [password, setPassword] = useState(Math.random().toString(36).substring(7));
  const [menu_cobradores, setMenuCobradores] = useState(false);
  const [facturas_abonos_create, setFacturasAbonosCreate]= useState(false)
  const [validaBoton, setValidaBoton] = useState(true);

  const clear = () => {
    setNombre("");
    setApellido("");
    // setIdentificacion("");
    // setDireccion("");
    // setFechaIngreso("");
    // setFechaNacimiento("");
    setTelefono("");
    // setFrecuencia("");
    // setContEmer("");
    // setTelEmer("");
    // setSueldoActual("");
    setObservaciones("");
    setPuestos([]);
    setSelectedPuesto("");
    // setBanco("");
    // setClabe("");
    // setCobrador("");
    setSelectedPlantel("");
    setSelectedArea("");
    setEmail("");
    setMenuCobradores(false)
    setFacturasAbonosCreate(false)
    setPassword("");
    setValidaBoton(true)
  };

  useEffect(() => {
    axios
      .get(URL_PUESTOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allPuestos = res.data;
        setPuestos(allPuestos);
      })
      .catch((err) => {
        console.log(err);
      });
    // axios
    //   .get(URL_PLANTELES, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((res) => {
    //     const allPlanteles = res.data;
    //     setPlanteles(allPlanteles);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    // axios
    //   .get(URL_AREAS, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((res) => {
    //     const allAreas = res.data;
    //     setAreas(allAreas);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
  }, []);

  const saveColaborador = async (event) => {
    if (cobrador=="Si"){
      setMenuCobradores(true)
      setFacturasAbonosCreate(true)
    } else {
      setMenuCobradores(false)
      setFacturasAbonosCreate(false)
    }
    event.preventDefault();
    setValidaBoton(false)
    try {
      await axios
        .post(
          URL_COLABORADORES,
          {
            nombre,
            apellido,
            // identificacion,
            email,
            // direccion,
            // fecha_ingreso,
            // fecha_nacimiento,
            // frecuencia,
            telefono,
            // contacto_emergencia,
            // telefono_emergencia,
            // sueldo_actual,
            observaciones,
            puestos: selectedPuesto,
            // banco,
            // clabe,
            cobrador,
            // ultimo_aumento: fecha_ingreso,
            // sueldo_anterior: 0,
            planteles: selectedPlantel,
            areas: selectedArea,
            acceso_sistema,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          axios
            .get(`${URL_COLABORADORES}/email/${email}`, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            })
            .then((response) => {
              const idPost = response.data[0]._id;
              axios
                .post(
                  URL_SIGNUP,
                  {
                    nombre,
                    apellido,
                    email,
                    password,
                    colaboradores: idPost,
                    planteles: selectedPlantel,
                    areas: selectedArea,
                    is_active: acceso_sistema,
                    menu_cobradores,
                    facturas_abonos_create
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {   
                  axios
                  .post(
                    URL_LOGS,
                    {
                      tipo:'Crear Empleado',
                      detalle: `Nombre: ${nombre} / Apellido: ${apellido}`,
                      user: user.id
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                      },
                    }
                  )
                  clear();
                  Swal.fire("Good job!", "Creado con exito", `success`);
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                });
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`,
      });
      console.log(error);
    }
  };

  return (
    <>
      <Header />
      <br />
      <br />
      {user.empleados_create ? (
        <div className="card container">
          <h3 align="center">Dar de alta un Colaborador</h3>
          <Form onSubmit={saveColaborador}>
            <Row>
              <Col md={4}>
                <Label>Nombre</Label>
                <Input
                  type="text"
                  placeholder="Nombre"
                  value={nombre}
                  required
                  onChange={(e) => {
                    setNombre(e.target.value);
                  }}
                />
              </Col>
              <Col md={4}>
                <Label>Apellido</Label>
                <Input
                  type="text"
                  placeholder="Apellido"
                  value={apellido}
                  required
                  onChange={(e) => {
                    setApellido(e.target.value);
                  }}
                />
              </Col>
              <Col md={4}>
                <Label>Email</Label>
                <Input
                  type="text"
                  placeholder="Email"
                  value={email}
                  required
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
              {/* <Col md={3}>
                <Label>Direccion</Label>
                <Input
                  type="text"
                  placeholder="Direccion completa"
                  value={direccion}
                  required
                  onChange={(e) => {
                    setDireccion(e.target.value);
                  }}
                />
              </Col> */}
              <Col md={3}>
                <Label className="mr-sm-2">Puesto</Label>
                <Input
                  type="select"
                  value={selectedPuesto}
                  required
                  onChange={(e) => {
                    setSelectedPuesto(e.target.value);
                  }}
                >
                  <option value="0">Selecciona un Puesto</option>
                  {puestos
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
                </Input>
              </Col>
              {/* <Col md={3}>
                <Label>Identificacion</Label>
                <Input
                  type="text"
                  placeholder="No. Identificacion oficial"
                  value={identificacion}
                  required
                  onChange={(e) => {
                    setIdentificacion(e.target.value);
                  }}
                />
              </Col> */}
              <Col md={3}>
                <Label>Telefono</Label>
                <Input
                  type="text"
                  placeholder="Numero de Telefono"
                  value={telefono}
                  required
                  onChange={(e) => {
                    setTelefono(e.target.value);
                  }}
                />
              </Col>


            {/* <Row> 
             <Col md={3}>
                <Label>Fecha de Nacimiento</Label>
                <Input
                  type="date"
                  value={fecha_nacimiento}
                  required
                  onChange={(e) => {
                    setFechaNacimiento(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Fecha de Ingreso</Label>
                <Input
                  type="date"
                  value={fecha_ingreso}
                  required
                  onChange={(e) => {
                    setFechaIngreso(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Sueldo</Label>
                <Input
                  type="text"
                  placeholder="Sueldo Actual"
                  value={sueldo_actual}
                  required
                  onChange={(e) => {
                    setSueldoActual(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Frecuencia</Label>
                <Input
                    type="select"
                    placeholder="Frecuencia"
                    value={frecuencia}
                    required
                    onChange={(e) => {
                      setFrecuencia(e.target.value);
                    }}
                  >
                    <option value="0">Frecuencia</option>
                    <option value="Semanal">Semanal</option>
                    <option value="Quincenal">Quincenal</option>
                    <option value="Mensual">Mensual</option>
                  </Input>
              </Col>
            </Row> */}

              {/* <Col md={3}>
                <Label>Banco</Label>
                <Input
                  type="text"
                  placeholder="Banco"
                  value={banco}
                  required
                  onChange={(e) => {
                    setBanco(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Clabe</Label>
                <Input
                  type="number"
                  placeholder="Clabe"
                  value={clabe}
                  required
                  onChange={(e) => {
                    setClabe(e.target.value);
                  }}
                />
              </Col> */}
              {/* {user.planteles == PLANTELES_GENERAL ? (
                <Col md={4}>
                  <Label className="mr-sm-2">Planteles</Label>
                  <Input
                    type="select"
                    value={selectedPlantel}
                    onChange={(e) => setSelectedPlantel(e.target.value)}
                  >
                    <option value="0">Selecciona</option>
                    {planteles
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => {
                          return <option value={a._id}>{a.name}</option>
                      })}
                  </Input>
                </Col>
              ) : (
                <Col md={4}>
                  <Label className="mr-sm-2">Planteles</Label>
                  <Input
                    type="select"
                    value={selectedPlantel}
                    onChange={(e) => setSelectedPlantel(e.target.value)}
                  >
                    <option value="0">Selecciona</option>
                    {planteles
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => {
                        if (a._id == user.planteles) {
                          return <option value={a._id}>{a.name}</option>;
                        }
                      })}
                  </Input>
                </Col>
              )} */}
              {/* <Col md={3}>
                <Label>Contacto Emergencia</Label>
                <Input
                  type="text"
                  placeholder="Nombre del contacto"
                  value={contacto_emergencia}
                  required
                  onChange={(e) => {
                    setContEmer(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Telefono Emergencia</Label>
                <Input
                  type="text"
                  placeholder="Telefono del contacto"
                  value={telefono_emergencia}
                  required
                  onChange={(e) => {
                    setTelEmer(e.target.value);
                  }}
                />
              </Col> */}
              {/* {user.areas == AREAS_GENERAL ? (
                <Col md={4}>
                  <Label className="mr-sm-2">Areas</Label>
                  <Input
                    type="select"
                    value={selectedArea}
                    required
                    onChange={(e) => setSelectedArea(e.target.value)}
                  >
                    <option value="0">Selecciona</option>
                    {areas
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => {
                          return <option value={a._id}>{a.name}</option>
                      })}
                  </Input>
                </Col>
              ) : (
                <Col md={4}>
                  <Label className="mr-sm-2">Areas</Label>
                  <Input
                    type="select"
                    value={selectedArea}
                    required
                    onChange={(e) => setSelectedArea(e.target.value)}
                  >
                    <option value="0">Selecciona</option>
                    {areas
                     .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => {
                        if (user.areas == a._id) {
                          return <option value={a._id}>{a.name}</option>;
                        }
                      })}
                  </Input>
                </Col>
              )} */}
              <Col md={3}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Acceso al Sistema
                </Label>
                <Input
                  type="select"
                  value={acceso_sistema}
                  required
                  onChange={(e) => {
                    setAccesoSistema(e.target.value);
                  }}
                >
                  <option value="0">Acceso al Sistema</option>
                  <option value="No">No</option>
                  <option value="Si">Si</option>
                </Input>
              </Col>
              {/* <Col md={2}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Cobrador
                </Label>
                <Input
                  type="select"
                  value={cobrador}
                  required
                  onChange={(e) => {
                    setCobrador(e.target.value);
                  }}
                >
                  <option value="0">Es Cobrador</option>
                  <option value="No">No</option>
                  <option value="Si">Si</option>
                </Input>
              </Col> */}
              {/* <Col md={2}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Maestro
                </Label>
                <Input
                  type="select"
                  value={maestro}
                  required
                  onChange={(e) => {
                    setMaestro(e.target.value);
                  }}
                >
                  <option value="0">Es Maestro</option>
                  <option value="No">No</option>
                  <option value="Si">Si</option>
                </Input>
              </Col> */}
              
              <Col md={3}>
                <Label>Password</Label>
                <Input type="text" placeholder={password} disabled />
              </Col>
              
            </Row>
            <Row>
              <Col md={6}>
                <Label for="exampleText">Observaciones</Label>
                <Input
                  type="textarea"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
            </Row>
            {validaBoton ? (
        <Button type="submit" className="btn btn-success">
        Guardar
      </Button>
      ):(
      <Button type="submit" className="btn btn-success" disabled>
        Guardar
      </Button>)}
            <Button
              href="/Empleados"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
            <div>
              <SweetAlert
                show={text}
                title="Creado con Exito"
                // text="SweetAlert in React"
                onConfirm={() => {
                  setText(false);
                  window.location.href = "/Empleados";
                }}
              />
            </div>
          </Form>
          <br />
        </div>
      ) : undefined}
    </>
  );
}

export default ColaboradoresCreate;
